/**
 * Tokenized US stocks on Robinhood Chain trade 24/5: from Sunday 8:00 PM to Friday 8:00 PM, New York time, and
 * not on NYSE holidays (the feeds showed no rounds on 2026-07-03 and 2026-09-07 until 8:00 PM that evening).
 * Outside the window the reference feeds hold the last traded price.
 */
const fmt = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: 'numeric', hourCycle: 'h23' });

/** NYSE full-day closures. Trading resumes at 8:00 PM New York time on the holiday itself (as on any weekday). */
export const NYSE_HOLIDAYS = new Set([
  '2026-01-01', '2026-01-19', '2026-02-16', '2026-04-03', '2026-05-25', '2026-06-19', '2026-07-03', '2026-09-07', '2026-11-26', '2026-12-25',
  '2027-01-01', '2027-01-18', '2027-02-15', '2027-03-26', '2027-05-31', '2027-06-18', '2027-07-05', '2027-09-06', '2027-11-25', '2027-12-24',
]);

interface NyTime { weekday: string; date: string; hour: number }
function newYork(now: Date): NyTime {
  const p = Object.fromEntries(fmt.formatToParts(now).map((x) => [x.type, x.value]));
  return { weekday: p.weekday!, date: `${p.year}-${p.month}-${p.day}`, hour: Number(p.hour) };
}

export function isUsStockMarketClosed(now: Date = new Date()): boolean {
  const { weekday, date, hour } = newYork(now);
  if (weekday === 'Sat') return true;
  if (weekday === 'Sun' && hour < 20) return true;
  if (weekday === 'Fri' && hour >= 20) return true;
  // a holiday closes the market from the previous evening's 8 PM until 8 PM on the holiday itself
  if (hour < 20) return NYSE_HOLIDAYS.has(date);
  return NYSE_HOLIDAYS.has(newYork(new Date(now.getTime() + 24 * 3600 * 1000)).date);
}

export const MARKET_HOURS_NOTE = 'US stocks trade 24/5 here: Sunday 8 PM to Friday 8 PM New York time, except NYSE holidays. While the market is closed the oracle holds the last traded price.';
